var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [!_vm.disabled && !_vm.editName ? _c('h3', {
    on: {
      "click": [_vm.editTemplateName, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_vm._v("\n      " + _vm._s(_vm.mutableValue) + "\n               \n      "), _c('span', {
    staticClass: "text-gray-600 inline-block cursor-pointer"
  }, [_c('icon', {
    attrs: {
      "name": "edit-2"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.disabled ? _c('h3', [_vm._v("\n      " + _vm._s(_vm.mutableValue) + "\n               \n    ")]) : _vm._e(), _vm._v(" "), !_vm.disabled && _vm.editName ? _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutableValue,
      expression: "mutableValue"
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.valid,
      expression: "valid"
    }],
    staticClass: "w-full text-center bg-white border rounded-md placeholder-gray-600 text-gray-900 py-2 px-3 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4 focus:outline-none focus:shadow-outline-indigo border-opacity-50 appearance-none transition duration-150 ease-in-out text-xl sm:leading-5 block truncate",
    class: {
      'border-red-500': _vm.error && _vm.errorMsg != '',
      'border-indigo-600': !(_vm.error && _vm.errorMsg != '')
    },
    attrs: {
      "type": "text",
      "maxlength": _vm.maxlength
    },
    domProps: {
      "value": _vm.mutableValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.mutableValue = $event.target.value;
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm.error && _vm.editName ? _c('div', {
    staticClass: "text-red-500 text-sm"
  }, [_vm._v("\n      " + _vm._s(_vm.errorMsg) + "\n    ")]) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }